import React from 'react';
import { Tag } from 'antd';
import './index.scss';

const PostBadges = ({ post, className = '', showPinned = true, showSchool = true }) => {
  const pinned = showPinned && post.is_pinned;
  const school = showSchool && post.school_name;
  return pinned || school ? <div className={`postBadges ${className}`} aria-label="帖子标记">
    {pinned && <Tag className="postBadges-pin">置顶</Tag>}
    {school && <Tag className="postBadges-school">{school}</Tag>}
  </div> : null;
};

export default PostBadges;
